import { z } from 'zod';

// Field validators
export const emailField = z.string().email('Please enter a valid email address').or(z.literal(''));

export const websiteField = z.string().refine(
  (value) => {
    if (!value || value.trim() === '') {
      return true;
    }
    let url = value;
    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.hostname.includes('.');
    } catch {
      return false;
    }
  },
  { message: 'Please enter a valid URL (e.g., example.com)' },
);

// Schema for creating a contact (modal)
export const createContactSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  phoneNumbers: z.array(z.string()).min(1, 'At least one phone number is required'),
  companyId: z.string().optional(),
  email: emailField.optional(),
  website: websiteField.optional(),
  job_title: z.string().optional(),
  address: z.string().optional(),
});

export type CreateContactFormData = z.infer<typeof createContactSchema>;

// Schema for editing a contact (side panel) - extends create with all fields optional + last_name
// Override name to allow empty strings (min(1) from createContactSchema rejects '' even after .partial())
export const editContactSchema = createContactSchema.partial().extend({
  name: z.string().optional(),
  last_name: z.string().optional(),
});

export type EditContactFormData = z.infer<typeof editContactSchema>;

// Utility to validate a single email
export function validateEmail(value: string): boolean {
  if (!value.trim()) return true;
  return emailField.safeParse(value).success;
}

// Utility to validate a single URL
export function validateWebsite(value: string): boolean {
  if (!value.trim()) return true;
  return websiteField.safeParse(value).success;
}
